import React from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { handleVisibleForEdit, handleDangerVisible } from "../../global/Utils";
import { updateBuyer } from "../../Actions/BuyerAction";
import AddBuyer from "./AddBuyer";

// Edit Buyer is the Add Buyer form - its tabs, live checks and ATL Status -
// opened with the buyer picked in the list and saved over it.
const EditBuyer = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const buyer = location.state || {};

  return (
    <AddBuyer
      buyer={buyer}
      onSave={(changes) =>
        dispatch(
          updateBuyer(
            buyer._id,
            changes,
            handleVisibleForEdit,
            handleDangerVisible,
            navigate,
          ),
        )
      }
      onCancel={() => navigate("/main/view-buyer-list")}
    />
  );
};

export default EditBuyer;
